import { environment } from '@environments/environment';

export const GET_BLOG_ARTICLES_QUERY = (
  langcode: string,
  blogType: 'b2b' | 'b2c',
  from: number,
  size: number,
  level2Category?: string
) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_blog ?? '',
  body: {
    from,
    size,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type: blogType,
            },
          },
          ...(level2Category
            ? [
                {
                  term: {
                    name: level2Category,
                  },
                },
              ]
            : []),
        ],
      },
    },
    sort: [
      {
        created_timestamp: {
          order: 'desc',
        },
      },
    ],
    _source: ['url', 'created', 'image', 'name', 'title'],
  },
});
